module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#automobile",
      toString: function () {
        return this.url;
      }
    }